import PropTypes from 'prop-types';

export const CANCEL_PLAN_TERMS_OF_USE_PROP_TYPES = {
  expiryDate: PropTypes.string.isRequired,
  termsOfUseUrl: PropTypes.string.isRequired,
  isTrial: PropTypes.bool.isRequired,
};
